import { render, staticRenderFns } from "./returnAmount.vue?vue&type=template&id=4e673f9a"
import script from "./returnAmount.vue?vue&type=script&lang=js"
export * from "./returnAmount.vue?vue&type=script&lang=js"
import style0 from "./returnAmount.vue?vue&type=style&index=0&id=4e673f9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports